"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getComponentText = (element) => {
    const textOverride = element.getAttribute('data-snowplow-component-text');
    if (textOverride !== null) {
        return textOverride;
    }
    let text = element.innerText;
    if (text === null || text === undefined || text === '') {
        const img = element.querySelector('img');
        if (img !== null) {
            text = img.alt;
            if (text === null || text === undefined || text === '') {
                return null;
            }
        }
        else {
            return null;
        }
    }
    return text;
};
exports.default = getComponentText;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0Q29tcG9uZW50VGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy9keW5hbWljQ29udGV4dC9nZXRDb21wb25lbnRUZXh0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsTUFBTSxnQkFBZ0IsR0FBRyxDQUFDLE9BQW9CLEVBQWlCLEVBQUU7SUFDN0QsTUFBTSxZQUFZLEdBQUcsT0FBTyxDQUFDLFlBQVksQ0FBQyw4QkFBOEIsQ0FBQyxDQUFDO0lBQzFFLElBQUksWUFBWSxLQUFLLElBQUksRUFBRTtRQUN2QixPQUFPLFlBQVksQ0FBQztLQUN2QjtJQUVELElBQUksSUFBSSxHQUFHLE9BQU8sQ0FBQyxTQUFTLENBQUM7SUFFN0IsSUFBSSxJQUFJLEtBQUssSUFBSSxJQUFJLElBQUksS0FBSyxTQUFTLElBQUksSUFBSSxLQUFLLEVBQUUsRUFBRTtRQUNwRCxNQUFNLEdBQUcsR0FBRyxPQUFPLENBQUMsYUFBYSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ3pDLElBQUksR0FBRyxLQUFLLElBQUksRUFBRTtZQUNkLElBQUksR0FBRyxHQUFHLENBQUMsR0FBRyxDQUFDO1lBQ2YsSUFBSSxJQUFJLEtBQUssSUFBSSxJQUFJLElBQUksS0FBSyxTQUFTLElBQUksSUFBSSxLQUFLLEVBQUUsRUFBRTtnQkFDcEQsT0FBTyxJQUFJLENBQUM7YUFDZjtTQUNKO2FBQU07WUFDSCxPQUFPLElBQUksQ0FBQztTQUNmO0tBQ0o7SUFFRCxPQUFPLElBQUksQ0FBQztBQUNoQixDQUFDLENBQUM7QUFFRixrQkFBZSxnQkFBZ0IsQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../../src/utils/dynamicContext/getComponentText.ts